module.exports = __webpack_public_path__ + "static/media/chevron-down.6b5374eb.svg";